import { PENDING, FAIL } from '../../reduxPromise'
import _ from 'lodash'

export const getIsLoading = (state) => _.get(state, 'idaps.status') === PENDING
export const getResults = (state) => _.get(state, 'idaps.results')
export const getIsError = (state) => _.get(state, 'idaps.status') === FAIL
export const getIdapsDrug = (state) => _.get(state, 'idaps.currentDrug')
